import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/AuthProvider";

/**
 * Route guard. Redirects unauthenticated visitors to /login (preserving
 * the intended destination via location.state).
 *
 * In production builds, auth is always enforced even when Supabase is
 * unconfigured (fail closed). In dev, unconfigured Supabase lets the
 * user through so landing pages render without a project.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { session, isLoading, configured } = useAuth();
  const location = useLocation();

  if (!configured) {
    if (import.meta.env.PROD) {
      return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return <>{children}</>;
  }
  if (isLoading) {
    return (
      <div className="grid h-full place-items-center text-muted-foreground">
        Chargement…
      </div>
    );
  }
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
